import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DEFAULT_NAMESPACE } from './i18n/types';

const isDevelopment = import.meta.env.MODE === 'development';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: ['es', 'en', 'de', 'ko', 'zh'],
    debug: isDevelopment,
    load: 'languageOnly',
    ns: [DEFAULT_NAMESPACE],
    defaultNS: DEFAULT_NAMESPACE,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: isDevelopment ? '/locales/add/{{lng}}/{{ns}}' : undefined,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
    },
    saveMissing: isDevelopment,
    missingKeyHandler: isDevelopment
      ? (lng, ns, key) => {
          console.warn(`Missing translation key: ${key} for language: ${lng} in namespace: ${ns}`);
        }
      : undefined,
  });

// Función para cargar traducciones de forma dinámica
export const loadNamespaceAsync = async (namespace: string, language?: string) => {
  try {
    await i18n.loadNamespaces(namespace);
    if (language) {
      await i18n.changeLanguage(language);
    }
  } catch (error) {
    console.error(`Error loading namespace ${namespace}:`, error);
  }
};

export default i18n;
